import {
  SearchCheckIcon,
  FileTextIcon,
  PackageCheckIcon,
  HammerIcon,
  ShieldCheckIcon,
} from 'lucide-react'
import type { ProcessStep } from '../types'

export const processSteps: ProcessStep[] = [
  {
    icon: SearchCheckIcon,
    title: { en: 'Free Inspection', es: 'Inspección Gratuita' },
    description: {
      en: 'A licensed technician assesses the structure, documents every issue with photos, and leaves you a detailed report. No obligation.',
      es: 'Un técnico con licencia evalúa la estructura, documenta cada problema con fotos y te deja un informe detallado. Sin compromiso.',
    },
    meta: { en: 'Scheduled within 48 hours', es: 'Agendada en 48 horas' },
  },
  {
    icon: FileTextIcon,
    title: { en: 'Detailed Estimate', es: 'Presupuesto Detallado' },
    description: {
      en: 'Transparent written pricing with several repair options so you can weigh scope against budget. No hidden fees, ever.',
      es: 'Precios transparentes por escrito con varias opciones de reparación para equilibrar alcance y presupuesto. Sin cargos ocultos.',
    },
    meta: { en: 'Written, itemized, no pressure', es: 'Por escrito, detallado, sin presión' },
  },
  {
    icon: PackageCheckIcon,
    title: { en: 'Material Selection', es: 'Selección de Materiales' },
    description: {
      en: 'We recommend the right barrier thickness, lumber grade, and hardware for your home — and explain why each one matters.',
      es: 'Recomendamos el grosor de barrera, grado de madera y herrajes correctos para tu casa, y explicamos por qué importa cada uno.',
    },
    meta: { en: 'Premium, code-compliant materials', es: 'Materiales premium según código' },
  },
  {
    icon: HammerIcon,
    title: { en: 'Expert Installation', es: 'Instalación Experta' },
    description: {
      en: 'Licensed crews work to Washington code, protect your living space, and clean the site at the end of every day.',
      es: 'Equipos con licencia trabajan según el código de Washington, protegen tu hogar y limpian el sitio cada día.',
    },
    meta: { en: 'Most jobs finish in 1–5 days', es: 'La mayoría termina en 1–5 días' },
  },
  {
    icon: ShieldCheckIcon,
    title: { en: 'Final Inspection & Warranty', es: 'Inspección Final y Garantía' },
    description: {
      en: 'We walk the finished work with you, verify every detail, and hand over written warranty documentation and long-term support.',
      es: 'Recorremos el trabajo terminado contigo, verificamos cada detalle y entregamos la garantía por escrito con soporte a largo plazo.',
    },
    meta: { en: 'Workmanship warranty included', es: 'Garantía de mano de obra incluida' },
  },
]
